import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppliedJobs } from "../../store/userSlice";

const AppliedJobs = () => {
  const dispatch = useDispatch();
  const { appliedJobs, status } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(fetchAppliedJobs());
  }, [dispatch]);

  return (
    <div className="applied-job-area">
      <div className="table-wrapper">
        <div className="table-title-filter">
          <div className="section-title">
            <h5>Applied Jobs:</h5>
          </div>
        </div>
        {status === "loading" ? (
          <p>Loading...</p>
        ) : (
          <table className="eg-table table category-table mb-30">
            <thead>
              <tr>
                <th>Job Title</th>
                <th>Apply Date</th>
                <th>Hospital</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {appliedJobs.length === 0 ? (
                <tr>
                  <td colSpan="4">No applied jobs found.</td>
                </tr>
              ) : (
                appliedJobs.map((job) => (
                  <tr key={job._id}>
                    <td>{job.jobTitle}</td>
                    <td>{job.applyDate ? new Date(job.applyDate).toLocaleDateString() : "-"}</td>
                    <td>{job.hospital || "-"}</td>
                    <td>{job.status || "Applied"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AppliedJobs;
